import styled from 'styled-components';

interface SectionTitleProps {
  children: string;
}

export const SectionTitle = ({ children }: SectionTitleProps) => {
  return <Title>{children}</Title>;
};

const Title = styled.h3`
  color: var(--Light-Scheme-Monochrome-black, #232429);

  /* Display/X-Large/xl-bold */
  font-family: Pretendard;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 23.4px */
`;
